import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { faHeart as cuorepieno } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { MenuProps } from 'antd';
import { Menu, Space, Typography } from 'antd';

import CmbLingua from '../../Combos/CmbLingua';
import sessionManager from '../../SessionManager';
import stringres from '../../translations/stringres';
import { GestionePreferiti } from './GestionePreferiti';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(label: React.ReactNode, key: React.Key, icon?: React.ReactNode, type?: 'divider'): MenuItem {
    return {
        key,
        icon,
        label,
        type,
    } as MenuItem;
}

type MenuMagazzinoClientiPars = {
    currentMenu: string;
};
export default function MenuMagazzinoClienti(par: MenuMagazzinoClientiPars) {
    const [current, setCurrent] = useState(par.currentMenu);
    const [preferitiCount, setPreferitiCount] = useState(0);

    const navigate = useNavigate();

    const logOutClick = () => {
        sessionStorage.removeItem('tokencliente');
        sessionStorage.removeItem('data');
        sessionManager.clearSession();

        navigate('/loginClienti');
    };

    const items: MenuItem[] = [
        getItem('Elenco Materiali', 'ElencoQualita', ''),
        getItem('Tutti i materiali', 'Magazzino', ''),
        getItem(
            <div style={{ position: 'relative', display: 'flex' }}>
                <div>{stringres.t('preferiti').toString()}</div>
                {preferitiCount !== 0 ? (
                    <div style={{ marginLeft: '5px', marginTop: '5px' }}>
                        <div style={{ position: 'absolute' }}>
                            <div style={{ position: 'absolute', top: '0px' }}>
                                <FontAwesomeIcon size="2x" icon={cuorepieno}></FontAwesomeIcon>
                            </div>
                            <div style={{ color: 'white', position: 'absolute', left: '10px', top: '-5px' }}>
                                {preferitiCount}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
            </div>,
            'Preferiti',
            ''
        ),
        getItem(<CmbLingua></CmbLingua>, 'lingua', ''),
    ];

    useEffect(() => {
        setPreferitiCount(GestionePreferiti.getAll().length);
    }, [GestionePreferiti.getAll()]);

    const onClick: MenuProps['onClick'] = (e) => {
        setCurrent(e.key);

        if (e.key === 'logout') logOutClick();
        else navigate('/' + e.key);
    };

    return (
        <div>
            <Menu
                className="menucentered"
                items={items}
                onClick={onClick}
                mode="horizontal"
                overflowedIndicator={<FontAwesomeIcon width={40} icon={faEllipsis} />}
            ></Menu>
        </div>
    );
}
